export default __webpack_public_path__ + "static/media/ReportBookmark.f29a2f7e.svg";